var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUspCream = function SvgUspCream(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 22,
    r: 22,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 54.6H10C7.87827 54.6 5.84344 53.7572 4.34315 52.2569C2.84285 50.7566 2 48.7218 2 46.6V36.6C2 36.0696 2.21071 35.5609 2.58579 35.1858C2.96086 34.8107 3.46957 34.6 4 34.6H40",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 34.6V30.6C8 29.5392 8.42143 28.5218 9.17157 27.7716C9.92172 27.0215 10.9391 26.6 12 26.6H44C45.0609 26.6 46.0783 27.0215 46.8284 27.7716C47.5786 28.5218 48 29.5392 48 30.6V32.6",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 26.6C12 20.6 16 14.6 22 14.6H30C32.0195 14.6453 34.0031 14.0609 35.6755 12.928C37.348 11.795 38.6264 10.1697 39.3333 8.27738C39.4587 7.9472 39.6699 7.65642 39.945 7.43499C40.2202 7.21356 40.5494 7.06948 40.8987 7.01759C41.2481 6.9657 41.6049 7.00789 41.9326 7.13979C42.2602 7.2717 42.5467 7.48856 42.7627 7.76804C50.632 18.3147 44 26.6 44 26.6",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 56.7334C62 59.3855 60.9464 61.9291 59.0711 63.8044C57.1957 65.6798 54.6522 66.7334 52 66.7334C49.3478 66.7334 46.8043 65.6798 44.9289 63.8044C43.0536 61.9291 42 59.3855 42 56.7334C42 50.144 50.3333 38.616 52 38.616C53.6667 38.616 62 50.1334 62 56.7334Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUspCream;